/**
    Parse images URL in order to display them corectly.
    If the value is null the function returns a default image.
 */

angular.module('filters').filter('imageUrlParse', () => (value) => {

    if (value) {

        return JSON.parse(`"${value}"`);

    }
    return 'https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png';

});



// WEBPACK FOOTER //
// ./scripts/filters/imageUrlParse.js